import { options_premiumSubOption_TravelSaving } from './premiumDashboardManageAssistantsSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import { ServiceOption } from 'owa-premium-manageassistant-option';

let premiumDashboardManageAssistantsSubCategory: OptionSubCategory = {
    key: 'manageAssistants',
    titleStringKey: options_premiumSubOption_TravelSaving,
    options: [ServiceOption],
};

export default premiumDashboardManageAssistantsSubCategory;
